/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentMapDto
 */
export interface EquipmentMapDto {
    /**
     * 
     * @type {number}
     * @memberof EquipmentMapDto
     */
    equipmentTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentMapDto
     */
    externalId?: string;
}

/**
 * Check if a given object implements the EquipmentMapDto interface.
 */
export function instanceOfEquipmentMapDto(value: object): value is EquipmentMapDto {
    return true;
}

export function EquipmentMapDtoFromJSON(json: any): EquipmentMapDto {
    return EquipmentMapDtoFromJSONTyped(json, false);
}

export function EquipmentMapDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentMapDto {
    if (json == null) {
        return json;
    }
    return {
        
        'equipmentTypeId': json['equipmentTypeId'] == null ? undefined : json['equipmentTypeId'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function EquipmentMapDtoToJSON(json: any): EquipmentMapDto {
    return EquipmentMapDtoToJSONTyped(json, false);
}

export function EquipmentMapDtoToJSONTyped(value?: EquipmentMapDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'equipmentTypeId': value['equipmentTypeId'],
        'externalId': value['externalId'],
    };
}

